'use client';

import { PlusIcon } from '@insta-club/components/icons';
import { Container } from '@insta-club/components/layout';
import { useSessionStore } from '@insta-club/state';
import { Button } from '@insta-club/ui';
import Link from 'next/link';

function RequirePage({ children }: { children: React.ReactNode }) {
    const hasNoPages = useSessionStore((state) => state.hasNoPages);
    const sessionStatus = useSessionStore((state) => state.status);

    if (!hasNoPages && sessionStatus !== 'loading') {
        return <>{children}</>;
    }

    return (
        <>
            <Container hasHeader className='flex h-full w-full items-center justify-center'>
                <div className='flex flex-col items-center space-y-8 text-center'>
                    <svg width='155' height='57' viewBox='0 0 155 57' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <rect y='0.5' width='155' height='56' rx='11' fill='#F3F4F6' />
                        <rect x='106' y='9.5' width='40' height='40' rx='11' fill='#292960' />
                        <rect x='55' y='17.5' width='40' height='6' rx='3' fill='#CBD4E7' />
                        <rect x='18' y='33.5' width='77' height='6' rx='3' fill='#F64D89' />
                        <path
                            d='M126.5 17.6667C123.771 17.6667 121.552 19.9742 121.552 22.8126C121.552 25.5967 123.646 27.8501 126.375 27.9476C126.458 27.9367 126.542 27.9367 126.604 27.9476C126.625 27.9476 126.636 27.9476 126.656 27.9476C126.667 27.9476 126.667 27.9476 126.677 27.9476C129.344 27.8501 131.438 25.5967 131.448 22.8126C131.448 19.9742 129.229 17.6667 126.5 17.6667Z'
                            fill='white'
                        />
                        <path
                            d='M131.792 30.8294C128.885 28.8144 124.146 28.8144 121.219 30.8294C119.896 31.7502 119.167 32.996 119.167 34.3285C119.167 35.661 119.896 36.896 121.208 37.806C122.667 38.8244 124.583 39.3335 126.5 39.3335C128.417 39.3335 130.333 38.8244 131.792 37.806C133.104 36.8852 133.833 35.6502 133.833 34.3069C133.823 32.9744 133.104 31.7394 131.792 30.8294ZM128.583 35.141H127.281V36.4952C127.281 36.9394 126.927 37.3077 126.5 37.3077C126.073 37.3077 125.719 36.9394 125.719 36.4952V35.141H124.417C123.99 35.141 123.635 34.7727 123.635 34.3285C123.635 33.8844 123.99 33.516 124.417 33.516H125.719V32.1619C125.719 31.7177 126.073 31.3494 126.5 31.3494C126.927 31.3494 127.281 31.7177 127.281 32.1619V33.516H128.583C129.01 33.516 129.365 33.8844 129.365 34.3285C129.365 34.7727 129.01 35.141 128.583 35.141Z'
                            fill='white'
                        />
                    </svg>
                    <div className='space-y-3'>
                        <h4 className='text-base font-semibold text-gray-800'>شروع کنید و تفاوت را تجربه کنید...</h4>
                        <p className='text-[15px] font-medium text-gray-500'>
                            دیگر نیازی به حدس زدن نیست! با ابزارهای هوشمند اینستاکلاب، به راحتی مخاطبان هدفمند خود را
                            پیدا کرده و فالوورهای واقعی جذب کنید. رشد سریع و پایدار در انتظار شماست!
                        </p>
                    </div>
                    <Link href={'/profile/add-page/intro'}>
                        <Button
                            icon={<PlusIcon className='text-white' />}
                            className='bg-primary-600! px-4! py-3.5! text-base! font-medium!'
                        >
                            افزودن اکانت اینستاگرام
                        </Button>
                    </Link>
                </div>
            </Container>
        </>
    );
}

export default RequirePage;

